// Shared motion presets used across home-page sections.
// Keeping these as module-level constants avoids creating new object
// references on every render of every consumer.

export const fadeUp = {
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};
